angular.module('qkr.merchant.reports')

    .controller('CurrentReportsController', function($routeSegment, reportService, reports, outlets,
                                                     $uibModal, utils, FormHelper, $location, merchantInfo,
                                                     outletService, $log, merchantService, paginationService) {
        const vm = this;
        vm.maxList = {};
        vm.maxList.list = [10, 20, 30, 50];
        vm.maxList.selected = 10;
        vm.maxList.label = vm.maxList.selected;
        vm.searchText = null;
        const outletId = $routeSegment.$routeParams.outletId;
        const isMerchantLocation = $location.path().includes('/merchant/reports')
        /* ----------------------------------------------------------------------------------------------*/
        //  Pagination functions

        vm.pageChanged = function(selectedPage, disabled) {
            if (!disabled) {
                vm.loadReports(selectedPage, (selectedPage - 1) * vm.maxList.selected,
                    vm.maxList.selected);
            }
        };

        vm.buildPage = function(itemAmount, currentPage, pageSize) {
            vm.pageService = paginationService.getPages(itemAmount, currentPage, pageSize);

            // Set visibility
            vm.isToShowFilterPagination = vm.pageService && vm.pageService.totalItems > 10 && !vm.noResult;
        };

        vm.reloadReports = function() {
            vm.loadReports(null, null, vm.maxList.selected);
        };

        vm.loadReports = function(currentPage, offset, max) {
            vm.noResult = null;

            const form = {
                searchText: vm.searchText === null ? null : vm.searchText.toLowerCase(),
                offset: offset || 0,
                max: max || 10
            };

            reportService.loadSavedReports(form).then((paginatedReports) => {
                reports = paginatedReports;
                vm.initializeReports(form);
            }, (reason) => {
                messageService.error(reason);
            });
        };

        vm.initializeReports = function(form) {
            vm.noResult = null;

            if (reports!= null && reports.length > 0 && reports[0] != null && reports[0].length > 0) {
                vm.buildPage(reports[1], form.offset, form.max);
                    if (isMerchantLocation || merchantService.behaviour(merchantInfo, 'schoolLike')) {
                        vm.savedReports = reports[0];
                    } else {
                        // filter by outlet, change made here to avoid side effects
                        const currentOutletSession = outletService.getChildOutletFromParentOutlet(outlets, outletId);
                        if (!currentOutletSession[0]) {
                            $log.error('There was an error to get outlet from outlets');
                            return [];
                        }
                        vm.savedReports = reportService.filterReportsNonSchoolOutlet(reports[0], currentOutletSession[0]);
                    }
            } else {
                vm.noResult = 'No results match your search! Please try another query.';
                vm.isToShowFilterPagination = false;
            }

        };
        /* ----------------------------------------------------------------------------------------------*/

        vm.unsuspendSavedReport = (savedReport, index) => {
            reportService.unsuspendReport(savedReport.id)
                .then(data => {
                    vm.savedReports[index] = angular.copy(data);
                })
                .catch(error => {
                    new FormHelper(vm).handleResponse(error);
                });
        };

        vm.suspendSavedReport = (savedReport, index) => {
            const modalInstance = $uibModal.open({
                template: require('../../../templates/report/reportSuspendDatepicker.html'),
                controller: 'ReportSuspendDatePickerController',
                windowClass: 'modal',
                backdrop: 'static'
            });

            modalInstance.result.then(result => {
                if (result !== 'cancel') {
                    vm.savedReports[index].saving = true;
                    reportService.suspendReport(vm.savedReports[index], result)
                        .then((promise) => {
                            vm.savedReports[index] = angular.copy(promise);
                            vm.savedReports[index].saving = false;
                        })
                        .catch(error => {
                            vm.savedReports[index].saving = false;
                            new FormHelper(vm).handleResponse(error);
                        });
                }
            });
        };

        vm.deleteSavedReport = function(savedReport) {
            let promise = {};
            switch (savedReport.bean) {
                case "TransactionReportSpec":
                    promise = reportService.deleteTransactionReport(savedReport.id); break;
                case "StickerReportSpec":
                    promise = reportService.deleteStickerReport(savedReport.id); break;
                case "TallyReportSpec":
                    promise = reportService.deleteTallyReport(savedReport.id); break;
                case "Cases21ReportSpec":
                    promise = reportService.deleteCases21Report(savedReport.id); break;
                case "StockLevelReportSpec":
                    promise = reportService.deleteStockReport(savedReport.id); break;
                case "ReconciliationReportSpec":
                    promise = reportService.deleteReconciliationReport(savedReport.id); break;
                case "Finance1ReportSpec":
                    promise = reportService.deleteFinance1Report(savedReport.id); break;
            }

            promise
                .then(() => $routeSegment.chain[1].reload())
                .catch(error => new FormHelper(vm).handleResponse(error));
        };

        vm.editSavedReport = function(savedReport) {
            if (savedReport.reportSubType === 'BYOR') {
                $location.path(`/byoredit/${outletId}/${savedReport.id}`);
                return;
            }

            const modalResult = (modal) => {
                modal.result
                    .then(() => $routeSegment.chain[1].reload())
                    .catch( reason => $log.log(reason))
            };

            let modalInstance;

            const reportCopy = Object.assign({}, savedReport);

            const accountancyPackageName = merchantInfo.accountancyPackage ?
                merchantInfo.accountancyPackage.name : '';

            if (savedReport.bean === 'TransactionReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/transaction.outlet.html'),
                    controller: 'TransactionOutletController',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName
                            };
                        },
                        savedReport() {
                            return reportCopy;
                        },
                        departments() {
                            if(outletId) {
                                return outletService.loadOutletDepartments(outletId);
                            }
                            return [];
                        },
                        isMerchantReport() {
                            return isMerchantLocation;
                        },
                        outlets() {
                            return outletService.listOutlets();
                        }
                    }
                });
                modalResult(modalInstance);
            } else if (savedReport.bean === 'StickerReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/sticker.html'),
                    controller: 'StickerController',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        savedReport() {
                            return reportCopy;
                        }
                    }
                });
                modalResult(modalInstance);
            } else if (savedReport.bean === 'TallyReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/tally.html'),
                    controller: 'TallyController',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        savedReport() {
                            return reportCopy;
                        }
                    }
                });
                modalResult(modalInstance);
            } else if (savedReport.bean === 'Cases21ReportSpec') {

                modalInstance = $uibModal.open({
                    template: require('../schedule/cases21.html'),
                    controller: 'Cases21ControllerModal',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: reportCopy
                            };
                        }
                    }
                });
                modalResult(modalInstance);

            } else if (savedReport.bean === 'StockLevelReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/stock.html'),
                    controller: 'StockController',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        savedReport() {
                            return reportCopy;
                        }
                    }
                });
                modalResult(modalInstance);
            } else if (savedReport.bean === 'ReconciliationReportSpec') {

                modalInstance = $uibModal.open({
                    template: require('../schedule/reconciliation.html'),
                    controller: 'ReconciliationControllerModal as vm',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: reportCopy
                            };
                        },
                        departments() {
                            return outlets;
                        }

                    }
                });
                modalResult(modalInstance);
            } else if (savedReport.bean === 'Finance1ReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/finance1.html'),
                    controller: 'Finance1ControllerModal as vm',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        savedReport() {
                            return reportCopy;
                        },
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: reportCopy
                            };
                        },
                        departments() {
                            return outletService.loadOutletDepartments(outletId);
                        }
                    }
                });
                modalResult(modalInstance);
            } else {
                $log.info("Report Type not prepared -> " + savedReport.bean);
            }

        };

        vm.scheduleSummary = function(savedReport) {
            return reportService.scheduleSummary(savedReport);
        };

        vm.getReportType = function(report) {
            return reportService.getReportType(report);
        };

        vm.getNextScheduledGeneration = function (report) {
            return utils.serverDateStringtoDate(report.nextScheduledGenerationDisplay);
        }

        const init = function() {
            const form = {
                offset: 0,
                max: 10
            };
           vm.initializeReports(form)
        };

        // Ng-init, simply call your init() Since your controller runs before
        init();
    });



// WEBPACK FOOTER //
// ./src/reports/outlet/current/current.component.js